module.exports = __webpack_public_path__ + "img/welcome.3fec3d48.png";